import * as Sentry from "@sentry/react";
import { CaptureConsole } from "@sentry/integrations";

/**
 * Errors to ignore in Sentry — browser noise, extensions, and handled HTTP errors.
 * Uses partial string matching (Sentry `ignoreErrors` default behavior).
 */
const IGNORE_ERRORS = [
  // Chrome/Edge AI translation feature
  "shouldUseDetectedLanguage",
  "aiTranslations",
  // 1Password browser extension
  "Object Not Found Matching Id",
  // Browser extension stylesheet access
  "CSSStyleSheet",
  "cross-origin stylesheet",
  // PostHog rate limiting
  "[PostHog.js]",
  // Browser extension service
  "[extensionService]",
  // Third-party script failures
  "Failed to load the PSL script",
  // Supabase browser compat (LockManager spec)
  "Navigator LockManager",
  // Unactionable unhandled rejection with no useful info
  "Non-Error promise rejection captured with value: undefined",
  // HTTP 401/402 — already handled via redirect to /logout and /payments
  "Request failed with status code 401",
  "Request failed with status code 402",
  // Third-party banner.js script — null element on insertAdjacentHTML
  "Cannot read properties of null (reading 'insertAdjacentHTML')",
];

export function initSentry() {
  Sentry.init({
    dsn: "https://53dd8c3b5f204cc6bc1a86bcb02454b0@o4505187811852288.ingest.sentry.io/4505187813228544",
    integrations: [
      new Sentry.BrowserTracing(),
      new Sentry.Replay(),
      new CaptureConsole({
        levels: ["error", "warn"],
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enabled: import.meta.env.PROD,
    ignoreErrors: IGNORE_ERRORS,
  });
}
